import { createReducer } from '@reduxjs/toolkit';
import {
  fetchDocumentsFailed,
  fetchHistoryFailed,
  fetchHistoryStarted,
  fetchHistorySucceeded,
  fetchRelatedProductsFailed,
  replaceBooking,
  restoreOriginalBooking,
  setBooking,
  setDocuments,
  setHistory,
  setOriginalBooking,
  setRelatedProducts,
  setStep,
  updateBooking,
} from '../../actions/booking';

export const initialState = {
  ...window.ecom.redux_initial_state.booking,
  step: 0,
  documents: [],
  api: { history: null },
};

const BookingReducer = createReducer(initialState, {
  [setBooking]: (state, action) => {
    state.current = action.payload;
  },
  [setOriginalBooking]: (state, action) => {
    state.original = action.payload;
  },
  [restoreOriginalBooking]: (state) => {
    if (state.original) {
      state.current = state.original;
    }
  },
  [updateBooking]: (state, action) => {
    state.current = { ...state.current, ...action.payload };
  },
  [replaceBooking]: (state, action) => {
    state.current = action.payload;
  },
  [setRelatedProducts]: (state, action) => {
    state.relatedProducts = action.payload;
  },
  [fetchRelatedProductsFailed]: (state) => state,
  [setStep]: (state, action) => {
    state.step = action.payload;
  },
  [setDocuments]: (state, action) => {
    state.documents = action.payload;
  },
  [fetchDocumentsFailed]: (state) => state,
  [setHistory]: (state, action) => {
    state.history = action.payload;
  },
  [fetchHistoryFailed]: (state) => {
    state.api.history = 'failed';
  },
  [fetchHistoryStarted]: (state) => {
    state.api.history = 'started';
  },
  [fetchHistorySucceeded]: (state) => {
    state.api.history = 'succeeded';
  },
});

export default BookingReducer;
